<script setup>
import EditInput from "@/components/global/inputs/EditInput.vue";
import { ref } from "vue";

const props = defineProps({
  packageBlogPosts: {
    type: [Number, String],
    required: true,
  },
  organisationId: {
    type: Number,
    required: true,
  },
});

const packageBlogPosts = ref(props.packageBlogPosts);

const updateUrl = `/admin/crm/organisations/${props.organisationId}/update-package-blog-posts`;

const success = (value) => packageBlogPosts.value = value;
</script>

<template>
  <EditInput
    :url="updateUrl"
    :current-value="packageBlogPosts"
    :confirm-before-save="true"
    confirm-title="Update Package Blog Posts"
    :confirm-text="`Are you sure you want to change the package blog posts from ${packageBlogPosts} to a new value?`"
    @success="success"
  >
    <strong>{{ packageBlogPosts }}</strong>
  </EditInput>
</template>
